import { Box, Divider, Grid, Typography } from "@material-ui/core"
import React from "react"
import { useStyles } from "./historico-pedido-valores-styles"
import { toDecimalString } from "utils/to-decimal"

export type HistoricoPedidoValoresProps = {
    vTotal: number
    vTaxaEntrega?: number
    vTaxaServico?: number
    vSubtotal?: number
}

export const HistoricoPedidoValores = ({ vTotal, vSubtotal, vTaxaEntrega, vTaxaServico }: HistoricoPedidoValoresProps) => {
    const classes = useStyles()

    return (
        <Grid container className={classes.container}>
            <Grid item xs={12} container justify="space-between">
                <Typography variant="body2" color="textSecondary" className={classes.textoTitle}>
                    Subtotal
                </Typography>
                <Typography variant="body1" color="textPrimary" className={classes.textoSubTotais}>
                    R$ {toDecimalString(vSubtotal)}
                </Typography>
            </Grid>
            {vTaxaEntrega !== undefined && (
                <Grid item xs={12} container justify="space-between">
                    <Typography variant="body2" color="textSecondary" className={classes.textoTitle}>
                        Taxa de Entrega
                    </Typography>
                    <Typography variant="body1" color="textPrimary" className={classes.textoSubTotais}>
                        R$ {toDecimalString(vTaxaEntrega)}
                    </Typography>
                </Grid>
            )}
            {vTaxaServico !== undefined && (
                <Grid item xs={12} container justify="space-between">
                    <Typography variant="body2" color="textSecondary" className={classes.textoTitle}>
                        Taxa de Serviço
                    </Typography>
                    <Typography variant="body1" color="textPrimary" className={classes.textoSubTotais}>
                        R$ {toDecimalString(vTaxaServico)}
                    </Typography>
                </Grid>
            )}
            <Grid item xs={12}>
                <Divider />
            </Grid>
            <Grid item xs={12} container justify="space-between">
                <Typography variant="h6" color="textPrimary" className={classes.textoTitleTotal}>
                    <Box component="span" fontWeight={500}>Total</Box>
                </Typography>
                <Typography variant="h6" color="textPrimary" className={classes.textoTotais}>
                    R$ {toDecimalString(vTotal)}
                </Typography>
            </Grid>
        </Grid>
    )
}